import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-elearning-about',
  templateUrl: './elearning-about.component.html',
  styleUrls: ['./elearning-about.component.scss']
})
export class ElearningAboutComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
